export { default } from './Logotips';
export type { LogotipsProps } from './Logotips.types';
